<template>
  <div class="bg-white p-3 h-100 dashboard-box-card" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
    <div class="text-left my-3">
      <span :style="'background-color: '+color+'; border-radius: 7px;padding: 0.8rem'">
        <slot></slot>
      </span>
    </div>
    <div class="px-2">
      <button v-if="showReloadButton" class="reload-btn" @click="emitReloadEvent">
        <i class="fa fa-sync" :class="{ rotating: isLoading }" style="font-size: 20px; color: #fff;"></i>
      </button>
      <span class="h4" style="letter-spacing: 2px;">{{ number }}</span>
      <span v-if="has_rail" class="mx-1">ریال</span>
    </div>
    <div class="my-2 px-2">
      <div class="h5">{{ title }}
        <a :href="info === 'پلن باشگاه مشتریان' ? 'https://paystar.ir/starclub' : '#'" target="_blank" v-if="info" class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm rounded-circle">
          <span class="tooltip-text" v-text="info"></span>
          <i class="fas fa-info-circle"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dashboard-box",
  props: {
    title: String,
    number: Number,
    color: String,
    info: String,
    has_rail: Boolean,
    showReloadButton: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitReloadEvent() {
      this.$emit("reload");
    }
  }
}
</script>

<style>
.reload-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  z-index: 100;
}
.special-tooltip{
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.special-tooltip .tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.special-tooltip .tooltip-text {
  font-size: 12px;
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  opacity: 0;
  transition: opacity 0.3s;
  min-width: 120px !important;
}

/*  rotating  */
.rotating {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(-360deg);
  }
}
@media (max-width: 767.98px) {
  .dashboard-box-card {
    padding: 0.75rem !important;
  }
  .dashboard-box-card .h4 {
    font-size: 1rem;
    letter-spacing: 0 !important;
  }
  .dashboard-box-card .h5 {
    font-size: 0.85rem;
  }
}
</style>
